import * as Styles from './error-label.module.less';

interface IErrorLabelProp {
    error?: string;
}

export const ErrorLabel = (props: IErrorLabelProp) => {
    return (
        <span className={Styles.fieldInputError} style={{ opacity: props.error ? 1 : 0 }}>
            {props.error}
            &nbsp;
        </span>
    );
};
